export const INTEREST = 'interest';
export const PROMISE = 'promise';
export const AGREEMENT_BASIC = 'agreement-basic';
export const AGREEMENT_FULL = 'agreement-full';